import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'

const IndexField = ({
  source,
  record = {},
  localize,
  translate,
  addLabel,
  sortable,
  locale,
  resource,
  format,
  index,
  tag: Tag = 'span',
  ...props
}) => {
  const no = index + 1
  return <Tag {...props}>{format ? format(no) : no}</Tag>
}

IndexField.propTypes = {
  index: PropTypes.number,
}

const PureIndexField = pure(IndexField)

export default PureIndexField



// WEBPACK FOOTER //
// ./ui/Data/IndexField.js